<ng-container [ngSwitch]="topline?.toplineItem?.itemType">

  <!--- Connection --->
  <app-topline-connection *ngSwitchCase="'EntityConnectionType'"
                          [parentEntityId]="parentEntityId"
                          [truncate]="true"
                          [topline]="topline">
  </app-topline-connection>

  <!--- Note --->
  <app-topline-note *ngSwitchCase="'Note'"
                    [topline]="topline"
                    [truncate]="true"
                    (addClick)="onAddClicked($event)">
  </app-topline-note>

  <!--- Age --->
  <app-topline-age *ngSwitchCase="'Age'"
                   [topline]="topline"
                   [truncate]="true"
                   (addClick)="onAddClicked($event)">
  </app-topline-age>


  <!--- Age --->
  <app-topline-preferred-language *ngSwitchCase="'PreferredLanguage'"
                                  [topline]="topline"
                                  [truncate]="true"
                                  (addClick)="onAddClicked($event)">
  </app-topline-preferred-language>

  <!-- Email -->
  <app-topline-email *ngSwitchCase="'Email'"
                     [topline]="topline"
                     [truncate]="true"
                     (addClick)="onAddClicked($event)"></app-topline-email>

  <!--Address-->
  <app-topline-address *ngSwitchCase="'Address'"
                       [topline]="topline"
                       [truncate]="true"
                       (addClick)="onAddClicked($event)"></app-topline-address>

  <app-topline-address *ngSwitchCase="'CityState'"
                       [topline]="topline"
                       [truncate]="true"
                       (addClick)="onAddClicked($event)"></app-topline-address>


  <!-- Phone Number-->
  <app-topline-phone *ngSwitchCase="'PhoneNumber'"
                     [topline]="topline"
                     [truncate]="true"
                     (addClick)="onAddClicked($event)"></app-topline-phone>

  <!-- Tag Category-->
  <app-topline-tag-category [topline]="topline"
                            [truncate]="true"
                            *ngSwitchCase="'TagCategory'"></app-topline-tag-category>

  <!-- Social -->
  <app-topline-social *ngSwitchCase="'SocialNetwork'"
                      [truncate]="true"
                      [topline]="topline"
                      (addClick)="onAddClicked($event)"></app-topline-social>

  <ng-container *ngSwitchDefault>
    <!--blank-->
  </ng-container>
</ng-container>
